import React from 'react';
import numeral from 'numeral';
import { Circle, Popup } from 'react-leaflet';
import { casesTypeColors } from './dicts';
import './components/Map/Map.css';

export const sortData = (data) => {
    const sortedData = [...data];

    return sortedData.sort((a, b) => a.cases > b.cases ? -1: 1)
};

export const preetyPrintStat = (stat, total=false) => {
    if (total) {
        return stat ? `${numeral(stat).format('0.0a')}` : 'Data unavaible';
    } else {
        return stat ? `+${numeral(stat).format('0,0')}` : 'Data unavaible';
    }
}
export const bulidChartData = (data, casesType='cases') => {
    const chartData = [];
    let lastDataPoint;

    for (let date in data.cases) {
        if (lastDataPoint) {
            const newDataPoint = {
                x:date,
                y: data[casesType][date] - lastDataPoint
            }
            chartData.push(newDataPoint)
        }
        lastDataPoint = data[casesType][date];
    }
    return chartData
};

export const showDataOnMap = (data, casesType='cases') =>
     data.map((country)=> (
        <Circle
            center={[country.countryInfo.lat, country.countryInfo.long]}
            fillOpacity={0.4}
            color={casesTypeColors[casesType].hex}
            fillColor={casesTypeColors[casesType].hex}
            radius={
                Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier
            }
            >
            <Popup>
                <div className="info-container">
                    <div
                        style={{ backgroundImage: `url(${country.countryInfo.flag})` }}
                        className="info-flag"
                    />
                    <div className="info-name">{country.country}</div>
                    {country.cases && <div className="info-confirmed">
                        Cases: {numeral(country.cases).format('0,0')}
                    </div>}
                    {country.recovered > 0 && <div className="info-recovered">
                        Recovered:{numeral(country.recovered).format('0,0')}
                    </div>}
                    {country.deaths > 0 && <div className="info-deaths">
                        Deaths: {numeral(country.deaths).format('0,0')}
                    </div>}
                    {country.recovered > 0 && country.deaths > 0 && country.cases > 0 &&
                    <div className="info-active">
                        Active: {numeral(country.cases-country.deaths-country.recovered).format('0,0')}
                    </div>}
                </div>
            </Popup>
        </Circle>
));
